import { render, staticRenderFns } from "./userAnswerFinal3round2.vue?vue&type=template&id=129c0e22&scoped=true"
import script from "./userAnswerFinal3round2.vue?vue&type=script&lang=js"
export * from "./userAnswerFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./userAnswerFinal3round2.vue?vue&type=style&index=0&id=129c0e22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c0e22",
  null
  
)

export default component.exports